import React from 'react';
import ReactSlider from 'react-slider';

const SliderComponent = ({ label, value, onChange, min, max, step, formattedValue }) => {
  return (
    <div style={{ marginBottom: '10px' }}>
      <label className="d-flex justify-content-between">
        <span className="loan_amount_p">{label}</span>
        <span className="loan_amount">{formattedValue}</span>
      </label>
      <ReactSlider
        className="horizontal-slider"
        thumbClassName="thumb"
        trackClassName="track"
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
      />
    </div>
  );
};

export default SliderComponent;
